export class PaginationModel {
    page: number;
    size: number;
}